import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import './App.css';
import './css/toast.css';
import axios from './axiosConfig';
import { cerrarSesion, toastError, toastSuccess } from './funciones.js';
import { getRoleFromToken } from './JwtUtils';
import { RoutesCustom } from './RoutesCustom';
function App() {
    //let intervalo;
    var intento = 1;

    useEffect(() => {
        document.addEventListener(
            "wheel",
            function (event) {
                const input = event.target.closest('input[type="number"]');

                if (input) {
                    event.preventDefault(); 
                }
            },
            { passive: false }
        );
        localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);

        if (localStorage.getItem(process.env.REACT_APP_FECHA_REFRESH) !== null &&
            localStorage.getItem(process.env.REACT_APP_TOKEN) !== null /*&& parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) !== -1*/) {
            refreshToken(false);
            /*intervalo = */setInterval(() => refreshToken(false), 60000);
        }

        /*if (parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) !== -1 &&
            parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) < Date.now()) {
            cerrarSesion(false);
        }*/
        if (parseInt(localStorage.getItem(process.env.REACT_APP_USUARIO_CREADO)) === 1) {
            toastSuccess("Usuario Registrado, se le informará por mail cuando sea aprobado")
            localStorage.removeItem(process.env.REACT_APP_USUARIO_CREADO);
        }
        if (parseInt(localStorage.getItem(process.env.REACT_APP_SESION_EXPIRADA)) === 1) {
            toastError("Su sesión expiró y no pudo ser reconectada")
            localStorage.removeItem(process.env.REACT_APP_SESION_EXPIRADA);
        }
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, [])

    function refreshToken(forzado) {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_REFRESH)) < Date.now() || forzado) {

            axios
                .put(process.env.REACT_APP_URL + 'empresa/refreshToken')
                .then((res) => {
                    localStorage.setItem(process.env.REACT_APP_FECHA_REFRESH, Date.now() + 1500000)
                    localStorage.setItem(process.env.REACT_APP_TOKEN, res.data);
                    intento = 0;
                })
                .catch(function (error) {
                    //toastError(handleError(error))
                })
            /*if(intento === 5){
                clearInterval(intervalo);
            }*/
            if (intento === 3 && !forzado) {
                cerrarSesion(true);
                localStorage.setItem(process.env.REACT_APP_SESION_EXPIRADA, 1);
            }
            intento++;
        }
    }

    window.onbeforeunload = function () {
        console.log(localStorage.getItem(process.env.REACT_APP_FECHA_REFRESH))
        if (/*parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) !== -1 &&*/ localStorage.getItem(process.env.REACT_APP_FECHA_REFRESH) !== null) {
            //localStorage.setItem(process.env.REACT_APP_FECHA_CIERRE, Date.now() + 1800000)
            refreshToken(true);
        }
        else if (parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) !== -1) {
            localStorage.removeItem(process.env.REACT_APP_MAIL_EMPRESA)
        }
        localStorage.removeItem(process.env.REACT_APP_ID_ACTIVIDAD);
    };

    return (
        <>{/*(parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) !== -1 &&
            parseInt(localStorage.getItem(process.env.REACT_APP_FECHA_CIERRE)) < Date.now())
            || localStorage.getItem(process.env.REACT_APP_ID_EMPRESA) === null ?
            */
            <RoutesCustom tipo={getRoleFromToken(localStorage.getItem(process.env.REACT_APP_TOKEN))} />
            //:        
        }
            <ToastContainer />
        </>
    );
}

export default App;
//<Route path = "/articulo/:idArticulo" element={<Artuculo/>} exact/> 